export const DISABLE_NAV = 'DISABLE_NAV'
export const TOGGLE_NAV = 'TOGGLE_NAV'
export const TOGGLE_NAV_SCROLL = 'TOGGLE_NAV_SCROLL'

export const ATTEMPT_SUBMIT_FORM = 'ATTEMPT_SUBMIT_FORM'
export const SUCCESS_SUBMIT_FORM =  'SUCCESS_SUBMIT_FORM'
export const FAILED_SUBMIT_FORM = 'FAILED_SUBMIT_FORM'
export const CLEAR_SUBMIT_FORM = 'CLEAR_SUBMIT_FORM'
